import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 0,
  class: /*@__PURE__*/_normalizeClass(`c-toast__icon`)
}
const _hoisted_2 = { class: "c-toast__txt" }

import { computed, onMounted, ref } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'Toast',
  props: {
  isToast: {
    type: Boolean,
    default: false,
  },
  close: {
    type: Boolean,
    default: false,
  },
  icon: {
    type: String,
    default: '',
  },
  width: {
    type: String,
    default: '',
  },
  desc: {
    type: String,
    default: '',
  },
  onClose: {
    type: Function,
    default: () => {},
  },
},
  setup(__props) {

const props = __props;

// default width
const computedWidth = computed(() => {
  return props.width == '' && isMobile ? '32rem' : '47rem';
})

// check device
const isMobile = ref(true);

const checkIsMobile = () => {
  isMobile.value = window.innerWidth < 767;
}

onMounted(() => {
  checkIsMobile();
  window.addEventListener('resize', checkIsMobile);
});

return (_ctx: any,_cache: any) => {
  return (__props.isToast)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(`c-toast z-[10000] c-toast--${__props.close ? 'close' : 'default'} c-toast--${
      __props.icon.length > 0 ? `${__props.icon}` : 'default'
    } fixed bottom-[20px] left-[20px] ${isMobile.value ? 'mo' : ''}`),
        style: _normalizeStyle({ width: computedWidth.value })
      }, [
        (__props.icon.length > 0)
          ? (_openBlock(), _createElementBlock("i", _hoisted_1, _cache[1] || (_cache[1] = [
              _createElementVNode("span", { class: "s-hide" }, "toast icon", -1)
            ])))
          : _createCommentVNode("", true),
        _createElementVNode("span", _hoisted_2, [
          _renderSlot(_ctx.$slots, "default", {}, () => [
            _createTextVNode(_toDisplayString(__props.desc), 1)
          ])
        ]),
        (__props.close)
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              type: "button",
              class: "c-toast__close",
              onClick: _cache[0] || (_cache[0] = () => __props.onClose())
            }, _cache[2] || (_cache[2] = [
              _createElementVNode("i", { class: "c-icon c-icon--close" }, null, -1),
              _createElementVNode("span", { class: "s-hide" }, "close", -1)
            ])))
          : _createCommentVNode("", true)
      ], 6))
    : _createCommentVNode("", true)
}
}

})